import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';
import { connect } from 'react-redux';
import {
    getChallengeCodeUpdating,
    getChallengeUpdateError,
} from '../selectors';
import {
    updateChallengeCodeRequested,
    clearChallengeUpdateError,
} from '../actions';
import EditIcon from '@material-ui/icons/EditOutlined';
import DeleteIcon from '@material-ui/icons/DeleteOutlineOutlined';
import Check from '@material-ui/icons/CheckOutlined';
import Cross from '@material-ui/icons/ClearOutlined';
import IconButton from '@material-ui/core/IconButton';

function CodesTable({
    challengeCodes,
    updateChallengeCode,
    isAdding,
    error,
    canUpdateCodes,
    clearError,
}) {
    const [isEditing, setIsEditing] = React.useState(null);
    const [code, setCode] = React.useState(null);
    const disabledEdit = false; // TODO: Revert this in order to make challenge code editable

    const setEditing = (element) => {
        setIsEditing(element.id);
        setCode(element.code);
        clearError();
    };

    const onSave = () => {
        updateChallengeCode({ payload: { code, id: isEditing } });
    };

    const onDelete = (element) => {
        updateChallengeCode({
            payload: {
                code: element.code,
                id: element.id,
                isActive: false,
                isVisible: false,
            },
        });
    };

    const onCancel = () => {
        setIsEditing(null);
        clearError();
    };

    React.useEffect(() => {
        if (!isAdding && !error) {
            setIsEditing(null);
            setCode(null);
        }
    }, [isAdding]);

    return (
        <div className="challengeCodesCard">
            <table className="table table-striped">
                <thead>
                    <th>Code</th>
                    <th>Participant Count</th>
                    <th>Litter Count</th>
                    {disabledEdit && <th>Action</th>}
                </thead>
                <tbody>
                    {challengeCodes.map((element) => (
                        <tr key={element.id}>
                            <td style={{ textTransform: 'uppercase' }}>
                                {element.code && isEditing === element.id ? (
                                    <>
                                        <div className="edit-code-form">
                                            <TextField
                                                value={code}
                                                minLength="4"
                                                maxLength="10"
                                                error={error.length > 0}
                                                helperText={error}
                                                type={'text'}
                                                placeholder={
                                                    'Enter new join code'
                                                }
                                                onChange={(event) =>
                                                    setCode(event.target.value)
                                                }
                                            />
                                            <IconButton
                                                onClick={() => onSave()}
                                                disabled={
                                                    !code ||
                                                    code.length > 10 ||
                                                    code.length < 4
                                                }
                                            >
                                                <Check
                                                    color={
                                                        !code ||
                                                        code.length > 10 ||
                                                        code.length < 4
                                                            ? 'disabled'
                                                            : 'primary'
                                                    }
                                                />
                                            </IconButton>
                                            <IconButton
                                                onClick={() => onCancel()}
                                            >
                                                <Cross color="error" />
                                            </IconButton>
                                        </div>
                                    </>
                                ) : element.code ? (
                                    element.code
                                ) : (
                                    '------'
                                )}
                            </td>
                            <td>{element.totalUsers}</td>
                            <td>{element.totalLitters}</td>
                            {disabledEdit && (
                                <td>
                                    {element.code ? (
                                        <>
                                            <IconButton
                                                disabled={
                                                    !canUpdateCodes ||
                                                    (element.code &&
                                                        isEditing ===
                                                            element.id) ||
                                                    element.totalLitters > 0 ||
                                                    element.totalUsers > 0
                                                }
                                                onClick={() =>
                                                    setEditing(element)
                                                }
                                            >
                                                <EditIcon
                                                    color={
                                                        !canUpdateCodes ||
                                                        (element.code &&
                                                            isEditing ===
                                                                element.id) ||
                                                        element.totalLitters >
                                                            0 ||
                                                        element.totalUsers > 0
                                                            ? 'disabled'
                                                            : 'primary'
                                                    }
                                                />
                                            </IconButton>
                                            <IconButton
                                                disabled={
                                                    !canUpdateCodes ||
                                                    (element.code &&
                                                        isEditing ===
                                                            element.id) ||
                                                    element.totalLitters > 0 ||
                                                    element.totalUsers > 0
                                                }
                                                onClick={() =>
                                                    onDelete(element)
                                                }
                                            >
                                                <DeleteIcon
                                                    color={
                                                        !canUpdateCodes ||
                                                        (element.code &&
                                                            isEditing ===
                                                                element.id) ||
                                                        element.totalLitters >
                                                            0 ||
                                                        element.totalUsers > 0
                                                            ? 'disabled'
                                                            : 'error'
                                                    }
                                                />
                                            </IconButton>
                                        </>
                                    ) : null}
                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

CodesTable.propTypes = {
    challengeCodes: PropTypes.array,
    updateChallengeCode: PropTypes.func,
    isAdding: PropTypes.bool,
    error: PropTypes.string,
    canCreateNewCodes: PropTypes.bool,
    canUpdateCodes: PropTypes.bool,
    clearError: PropTypes.func,
};

CodesTable.defaultProps = {
    challengeCodes: [],
    updateChallengeCode: () => {},
    isAdding: false,
    error: '',
    canCreateNewCodes: false,
    canUpdateCodes: false,
    clearError: () => {},
};

const mapStateToProps = (state) => {
    return {
        isAdding: getChallengeCodeUpdating(state),
        error: getChallengeUpdateError(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateChallengeCode: (data) =>
            dispatch(updateChallengeCodeRequested(data)),
        clearError: () => dispatch(clearChallengeUpdateError()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CodesTable);
